import {Routes} from '@angular/router';
import {ForbiddenComponent} from '../forbidden/forbidden.component';
import {onboardedGuard} from '../core/guards/onboarded.guard';
import {OauthFlowComponent} from '../auth/oauth-flow/oauth-flow.component';

export const routes: Routes = [
  {
    path: 'assets',
    loadChildren: () => import('../assets/routes').then(m => m.routes),
    canActivate: [onboardedGuard],
    canActivateChild: [onboardedGuard],
  },
  {
    path: 'billing',
    loadChildren: () => import('../billing/routes').then(m => m.routes),
    canActivate: [onboardedGuard],
    canActivateChild: [onboardedGuard],
    data: {
      role: 'can_read_billing',
      layout: {
        header: true,
        sidenav: true,
        footer: false
      }
    }
  },
  {
    path: 'login',
    loadComponent: () => OauthFlowComponent,
    data: {
      layout: {
        header: false,
        sidenav: false,
        footer: false
      },
      autoInitiate: true,
      redirectOnSuccess: '/overview'
    }
  },
  {
    path: 'auth/callback',
    loadComponent: () => OauthFlowComponent,
    data: {
      layout: {
        header: false,
        sidenav: false,
        footer: false
      },
      autoInitiate: false,
      redirectOnSuccess: '/overview'
    }
  },
  {
    path: 'logout',
    loadComponent: () => OauthFlowComponent,
    data: {
      layout: {
        header: false,
        sidenav: false,
        footer: false
      },
      autoInitiate: false,
      showActions: true,
    }
  },
  {
    path: 'integrations',
    loadComponent: () => import('../integrations/component').then(m => m.IntegrationsComponent),
    title: 'Integrations',
    canActivate: [onboardedGuard],
    canActivateChild: [onboardedGuard],
    data: {
      layout: {
        header: true,
        sidenav: false,
        footer: false
      }
    }
  },
  {
    path: 'overview',
    loadComponent: () => import('../overview/component').then(m => m.OverviewComponent),
    canActivate: [onboardedGuard],
    title: 'Overview',
    data: {
      layout: {
        header: true,
        sidenav: true,
        footer: false
      }
    }
  },
  {
    path: 'settings',
    loadComponent: () => import('../settings/settings.component').then(m => m.SettingsComponent),
    canActivate: [onboardedGuard],
    title: 'Settings',
    data: {
      role: 'can_view_settings',
      layout: {
        header: true,
        sidenav: true,
        footer: false
      }
    },
  },
  {
    path: 'search',
    loadComponent: () => import('../search/search.component').then(m => m.SearchComponent),
    canActivate: [onboardedGuard],
    title: 'Search',
    data: {
      layout: {
        header: true,
        sidenav: true,
        footer: false
      }
    },
  },
  {
    path: 'org',
    loadChildren: () => import('../org/routes').then(m => m.routes),
    canActivate: [],
    canActivateChild: [],
  },
  {
    path: 'forbidden',
    loadComponent: () => ForbiddenComponent,
    data: {
      layout: {
        header: true,
        sidenav: true,
        footer: false
      }
    }
  },
  {
    path: 'tos',
    loadComponent: () => import('../tos/tos.component').then(m => m.TosComponent),
    data: {
      layout: {
        header: false,
        sidenav: false,
        footer: false
      }
    },
    pathMatch: 'full',
    title: 'TrackStream | Terms of Service',
  },
  {
    path: 'privacy',
    loadComponent: () => import('../tos/pp.component').then(m => m.PrivacyPolicyComponent),
    data: {
      layout: {
        header: false,
        sidenav: false,
        footer: false
      }
    },
    pathMatch: 'full',
    title: 'TrackStream | Privacy Policy',
  },
  {
    path: '',
    loadChildren: () => import('../landing-page/route').then(m => m.landingRoute),
    canActivate: [],
    canActivateChild: [],
  },
  {
    path: '**',
    redirectTo: '',
  }
];
